﻿export default class ZoomControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.zoomIn = 'zoom-in-' + this.classId + '-' + this.action.Id;
        this.zoomOut = 'zoom-out-' + this.classId + '-' + this.action.Id;
    }

    init() {
        if (this._isMobileDevice()) return;
        let div = document.createElement('div');
        div.innerHTML = this._getTemplate();

        this.menuContainer.append(div.firstChild);

        $('#' + this.zoomIn).on('click', () => {
            this.mapControl.zoomIn();
        });

        $('#' + this.zoomOut).on('click', () => {
            this.mapControl.zoomOut();
        });
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _getTemplate() {
        return `<div class="map-zoom-tools">
                    <ul class="map-zoom-tools-list">
                        <li id="` + this.zoomIn + `" class="map-zoom-tools-item header-icon zoom-in shadow-4" title="` + this.resourcesHandler.get("Zoom in") + `">
                            <i class="fal fa-plus">
                            </i>
                        </li>
                        <li id="` + this.zoomOut + `" class="map-zoom-tools-item header-icon zoom-out shadow-1" title="` + this.resourcesHandler.get("Zoom out") + `">
                            <i class="fal fa-minus">
                            </i>
                        </li>
                    </ul>
                </div>`;
    }
}